import { useState } from 'react';
import { systemFlow } from '@/mocks/tradingData';
import Reveal from '@/components/base/Reveal';

function Philosophy() {
  const [active, setActive] = useState(0);

  return (
    <section id="philosophy" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start">
          <Reveal>
            <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[34px] leading-[1.08] sm:text-[44px] lg:text-[52px]">
              Not Every Gold Move Is a Trade.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-[15px] md:text-base leading-relaxed text-foreground-600 lg:pt-3 max-w-[560px]">
              Gold can move rapidly through different market conditions. The EA is designed to
              evaluate the market before executing a position rather than treating every price
              movement as an entry opportunity.
            </p>
          </Reveal>
        </div>

        {/* flow */}
        <Reveal delay={160} className="mt-14">
          <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
            <div className="flex flex-col lg:flex-row items-stretch">
              {systemFlow.map((step, idx) => (
                <div key={step.key} className="flex-1 flex flex-col lg:flex-row items-stretch">
                  <button
                    type="button"
                    onMouseEnter={() => setActive(idx)}
                    onFocus={() => setActive(idx)}
                    onClick={() => setActive(idx)}
                    className={`flex-1 text-left px-5 md:px-6 py-6 md:py-7 cursor-pointer transition-colors duration-300 ${
                      active === idx ? 'bg-accent-100' : 'bg-transparent hover:bg-background-100'
                    }`}
                  >
                    <span
                      className={`block font-data text-[10px] tracking-[0.2em] mb-3 ${
                        active === idx ? 'text-primary-600' : 'text-foreground-400'
                      }`}
                    >
                      0{idx + 1}
                    </span>
                    <span
                      className={`block font-heading font-bold text-[17px] md:text-[19px] tracking-tight transition-colors duration-300 ${
                        active === idx ? 'text-foreground-950' : 'text-foreground-600'
                      }`}
                    >
                      {step.key}
                    </span>
                    <span className="block mt-2.5 text-[13px] leading-relaxed text-foreground-500">
                      {step.detail}
                    </span>
                  </button>
                  {idx < systemFlow.length - 1 && (
                    <div className="flex items-center justify-center lg:px-1 py-1 lg:py-0">
                      <span className="w-4 h-4 flex items-center justify-center text-background-400">
                        <i className="ri-arrow-right-line hidden lg:inline"></i>
                        <i className="ri-arrow-down-line lg:hidden"></i>
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default Philosophy;